import { FloatButton } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import type { TourContext } from "./raidTourStore";
import { useRaidTourStore } from "./raidTourStore";

type Props = {
  context: TourContext;
};

export function RaidTourLauncher({ context }: Props) {
  const { start, activeContext } = useRaidTourStore();

  if (activeContext) return null;

  return (
    <FloatButton
      icon={<QuestionCircleOutlined />}
      tooltip="Tour starten"
      onClick={() => start(context)}
    />
  );
}
